import { apiFetch } from 'services/apiClient';
import DocumentService from 'services/DocumentService';
import { bulkUpdateAppointmentsByProposalAndAccount } from '../../inspection-appointments/services/inspection-appointmentService';

export const getInspectorKatipTasks = (): Promise<any[]> =>
  apiFetch('/inspection-appointments/me/status/7');

export const getInspectorKatipMissingContractCount = (): Promise<{ count: number }> =>
  apiFetch('/inspection-appointments/me/missing-contract/count');

export const listInspectorKatipMissingContracts = (): Promise<any[]> =>
  apiFetch('/inspection-appointments/me/all?contractId.specified=false&contractUrl.specified=false&isCompanyProcessDone.equals=true&sort=startDate,ASC');

export const uploadProposalContract = async ({
  proposalId,
  accountId,
  contractId,
  file,
}: {
  proposalId: number;
  accountId: number;
  contractId?: string;
  file?: File | null;
}): Promise<void> => {
  let contractUrl: string | undefined;

  if (file) {
    const uploadResponse: any = await DocumentService.postDocument(file, 'appointment_contract');
    const documentId = uploadResponse?.data?.id ?? uploadResponse?.data?.data?.id;
    if (documentId) {
      const documentResponse: any = await DocumentService.getDocument(documentId);
      contractUrl = documentResponse?.data?.preSignUrl ?? documentResponse?.data?.preSignedUrl ?? undefined;
    }
  }

  await bulkUpdateAppointmentsByProposalAndAccount({
    proposalId,
    accountId,
    contractId,
    contractUrl,
  });
};
